import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'reviews-nps-provider',
  imports: [TranslateModule, CommonModule],
  templateUrl: './nps-provider.component.html',
  styleUrl: './nps-provider.component.scss',
})
export class NPSProviderComponent implements OnInit {
  @Input() providerNames$: Observable<string[]>;
  protected formattedProviderNames$: Observable<string>;
  private translateService = inject(TranslateService);
  ngOnInit(): void {
    const translatedAnd = this.translateService.instant('TEAM.AND');
    this.formattedProviderNames$ = this.providerNames$.pipe(
      map((names: string[] | undefined) => {
        if (!names || names.length === 0) {
          return '';
        }

        if (names.length === 1) return names[0];
        else if (names.length === 2) return `${names[0]} ${translatedAnd} ${names[1]}`;
        else {
          const allExceptLast = names.slice(0, -1).join(', ');
          const last = names[names.length - 1];
          return `${allExceptLast} ${translatedAnd} ${last}`;
        }
      }),
    );
  }
}
